/**
 * İSTEMCİ ZAMAN AŞIMI, BAĞLANTI YOKLUĞUNDAN AYRI (sıra 66b).
 *
 * İkisi de sunucudan yanıt almadan biter ve `statusCode: 0` taşır, ama
 * kullanıcıya söylenecek şey farklıdır: bağlantı yoksa istek HİÇ GİTMEDİ;
 * süre dolduysa istek gitmiş ve sunucu onu İŞLİYOR olabilir (ölçüldü:
 * `password/forgot` 30 sn geciktiğinde istemci 15 sn'de kesiyor, kod yine
 * de geliyordu). "Bağlantı yok" demek kullanıcıyı ikinci kodu istemeye
 * itiyordu.
 *
 * AD `AbortError` KALIR: zaman aşımı istemcinin kendi iptalidir ve iptali
 * adından tanıyan her yer (`rethrowAbort`, `normalizeApiError`, iptali
 * sınayan spec'ler) aynı davranmayı sürdürür. Ayrım yalnız `timedOut`
 * işaretindedir. Tanıma ÖRNEKLE değil İŞARETLE yapılır (`isRequestTimeout`):
 * Metro ya da jest paylaşılan paketi iki kopya yüklerse `instanceof` sessizce
 * yanlış döner.
 */
export class RequestTimeoutError extends Error {
    timeoutMs;
    timedOut = true;
    constructor(timeoutMs) {
        super(`request timed out after ${timeoutMs} ms`);
        this.timeoutMs = timeoutMs;
        this.name = 'AbortError';
    }
}
export function isRequestTimeout(error) {
    return (typeof error === 'object' &&
        error !== null &&
        error.name === 'AbortError' &&
        error.timedOut === true);
}
//# sourceMappingURL=request-timeout.js.map